import api from "@/services/api";
import { Component, Watch } from "vue-property-decorator";
import gridComponentBase from "../../../components/grid/gridComponentBase.vue";
import permessi from "@/config/permessi";

const _ENDPONT = api.endpoint.RICERCA_GARANZIE;

@Component({})
export default class ricercaGaranzieWebins extends gridComponentBase {
	get PERMESSI(): string[] {
		return [permessi.BK.Vendite.ADESIONI_POLIZZE_WEBINS];
	}
	}
